import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.32492 2.38751L15.0319 8.87259L19.9908 7.54386C21.3245 7.18651 22.6953 7.97796 23.0527 9.31163C23.41 10.6453 22.6186 12.0161 21.2849 12.3735L3.58932 17.115L0.425293 10.7159L3.59932 9.86539L5.27607 11.4867L8.61144 10.5929L4.60904 3.38318L8.32492 2.38751ZM2.00005 19H22V21H2.00005V19Z"}}]};

const FlightTakeoffFilled = Vue.extend<IconProps>({
  name: 'FlightTakeoffFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'flight-takeoff-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default FlightTakeoffFilled;
